var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnalysis(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "analysis 1",
    clipPath: "url(#clip0_200_4264)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4683"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4685"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_200_4264",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -1,
    width: 48,
    height: 49
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clipPath4691"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4689",
    d: "M0 -0.0010643H48V47.9989H0V-0.0010643Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_200_4264)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4687"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4693"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4695",
    d: "M7.93217 25.7172C7.93217 26.918 6.95877 27.8914 5.75802 27.8914C4.55727 27.8914 3.58386 26.918 3.58386 25.7172C3.58386 24.5164 4.55727 23.543 5.75802 23.543C6.95877 23.543 7.93217 24.5164 7.93217 25.7172Z",
    stroke: "#347AF0",
    strokeWidth: 1.45508,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4697"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4699",
    d: "M17.0535 21.149C17.0535 22.3498 16.08 23.3232 14.8793 23.3232C13.6785 23.3232 12.7051 22.3498 12.7051 21.149C12.7051 19.9482 13.6785 18.9748 14.8793 18.9748C16.08 18.9748 17.0535 19.9482 17.0535 21.149Z",
    stroke: "#347AF0",
    strokeWidth: 1.45508,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4701"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4703",
    d: "M26.174 12.0124C26.174 13.2131 25.2006 14.1865 23.9998 14.1865C22.799 14.1865 21.8256 13.2131 21.8256 12.0124C21.8256 10.8115 22.799 9.83821 23.9998 9.83821C25.2006 9.83821 26.174 10.8115 26.174 12.0124Z",
    stroke: "#347AF0",
    strokeWidth: 1.45508,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4705"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4707",
    d: "M35.2948 16.5805C35.2948 17.7813 34.3214 18.7546 33.1206 18.7546C31.9199 18.7546 30.9464 17.7813 30.9464 16.5805C30.9464 15.3796 31.9199 14.4063 33.1206 14.4063C34.3214 14.4063 35.2948 15.3796 35.2948 16.5805Z",
    stroke: "#347AF0",
    strokeWidth: 1.45508,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4709"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4711",
    d: "M44.4157 2.87635C44.4157 4.07719 43.4423 5.05051 42.2416 5.05051C41.0408 5.05051 40.0674 4.07719 40.0674 2.87635C40.0674 1.67551 41.0408 0.702194 42.2416 0.702194C43.4423 0.702194 44.4157 1.67551 44.4157 2.87635Z",
    stroke: "#347AF0",
    strokeWidth: 1.45508,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4713"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4715",
    d: "M34.3252 14.7704L41.0369 4.68582",
    stroke: "#347AF0",
    strokeWidth: 1.45508,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4717"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4719",
    d: "M25.9438 12.9865L31.1767 15.6073",
    stroke: "#347AF0",
    strokeWidth: 1.45508,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4721"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4723",
    d: "M16.4151 19.6102L22.4638 13.5512",
    stroke: "#347AF0",
    strokeWidth: 1.45508,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4725"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4727",
    d: "M7.70215 24.7431L12.9351 22.1222",
    stroke: "#347AF0",
    strokeWidth: 1.45508,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4729"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4731",
    d: "M8.10982 33.7637H3.40685C3.0821 33.7637 2.81885 34.027 2.81885 34.3516V47.2948H8.69772V34.3516C8.69772 34.027 8.43457 33.7637 8.10982 33.7637Z",
    stroke: "#347AF0",
    strokeWidth: 1.45508,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4733"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4735",
    d: "M17.2305 29.1962H12.5276C12.2029 29.1962 11.9395 29.4596 11.9395 29.7842V47.2956H17.8185V29.7842C17.8185 29.4596 17.5552 29.1962 17.2305 29.1962Z",
    stroke: "#347AF0",
    strokeWidth: 1.45508,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4737"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4739",
    d: "M26.351 20.0195H21.6482C21.3234 20.0195 21.0601 20.2827 21.0601 20.6074V47.2948H26.939V20.6074C26.939 20.2827 26.6758 20.0195 26.351 20.0195Z",
    stroke: "#347AF0",
    strokeWidth: 1.45508,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4741"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4743",
    d: "M1.24561 47.2948H46.7543",
    stroke: "#347AF0",
    strokeWidth: 1.45508,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4745"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4747",
    d: "M31.48 24.6274H30.7692C30.4444 24.6274 30.1812 24.8907 30.1812 25.2154V47.2948H36.06V25.2154C36.06 24.8907 35.7968 24.6274 35.472 24.6274H34.7612",
    stroke: "#347AF0",
    strokeWidth: 1.45508,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4749"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4751",
    d: "M45.1808 27.8606V11.4476C45.1808 11.1228 44.9176 10.8595 44.5929 10.8595H39.8899C39.5652 10.8595 39.3019 11.1228 39.3019 11.4476V47.2956H45.1808V31.1418",
    stroke: "#347AF0",
    strokeWidth: 1.45508,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_200_4264"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalysis);
export default __webpack_public_path__ + "static/media/Analysis.1f5e71cf93aef481f0c993c88c42360d.svg";
export { ForwardRef as ReactComponent };